<!--? Footer Start-->
<div class="footer-area section-bg" id="bgFooter">
  <div class="container">
    <div class="footer-top footer-padding">
      <!-- Footer Menu -->
      <div class="row d-flex justify-content-between">
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
          <div class="single-footer-caption mb-50">
            <div class="footer-tittle">
              <h4>Orari di apertura</h4>
              <ul>
                <li><span class="h4">Lunedì-Venerdì 7:00-22:00</span></li>
                <li><span class="h4">Sabato 8:00-18:00</span></li>
                <li><span class="h4">Domenica 8:00-13:00 (escluso luglio-agosto)</span></li>
                <!-- <li> Domeniche aperte: le prime due del mese</li> -->
              </ul>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
          <div class="single-footer-caption mb-50">
            <div class="footer-tittle">
              <h4>Contatti</h4>
              <div class="row d-flex justify-content-between">
                <div class="col">
                  <ul>
                    <li><a href="https://maps.app.goo.gl/tXz87r1Z3n4umQSr9"><em class="bi bi-pin-map"></em>&nbsp;Viale
                        Leonida Tonelli 82 - 00134 - Roma (RM)</a></li>
                    <li><a class="text-lowercase" href="mailto:{{mailFonte}}"><em
                          class="bi bi-envelope"></em>&nbsp;{{mailFonte}}</a>
                    </li>
                    <li><a href="tel:3201555850"><em class="bi bi-telephone"></em>&nbsp; 3201555850</a></li>
                    <li>
                      <div class="footer-social ">
                        <a href="https://www.facebook.com/fullmuscle.gym"><em class="fab fa-facebook-f"></em></a>
                        <a href="https://fullmuscle.eu"><em class="fas fa-globe"></em></a>
                        <a href="https://www.instagram.com/fullmuscle.laurentina"><em
                            class="fab fa-instagram"></em></a>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="col">
                  <ul>
                    <li><a href="https://maps.app.goo.gl/tXz87r1Z3n4umQSr9"><em class="bi bi-pin-map"></em>&nbsp;Via di Trigoria 57 - 00128 - Roma (RM)</a></li>
                    <li><a class="text-lowercase" href="mailto:{{mailTrigoria}}"><em
                          class="bi bi-envelope"></em>&nbsp;{{mailTrigoria}}</a>
                    </li>
                    <li><a href="tel:3513465069"><em class="bi bi-telephone"></em>&nbsp; 3513465069</a></li>
                    <li>
                      <div class="footer-social ">
                        <a href="https://www.facebook.com/fullmuscle.gym"><em class="fab fa-facebook-f"></em></a>
                        <a href="https://fullmuscle.eu"><em class="fas fa-globe"></em></a>
                        <a href="https://www.instagram.com/fullmuscle.trigoria"><em
                            class="fab fa-instagram"></em></a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Footer Bottom -->
    <div class="footer-bottom">
      <div class="row d-flex align-items-center">
        <div class="col-lg-12">
          <div class="footer-copy-right text-center">
            <p><!-- Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. -->
              Copyright &copy;
              <script>document.write(new Date().getFullYear());</script> All rights reserved FULL MUSCLE
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Footer End-->